import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Grid from '@blocks/Grid'
import React from 'react'

export default function FinishedSection(section: Admin.Resources.DashboardSection) {
    const { salon } = useSalonManagerContext()

    return (
        <Grid gap="10px">
            <h4>{section.name}</h4>
            <Grid gap="5px">
                <small>Limit</small>
                {section.limit 
                    ? <h5>{section.limit.number } / {salon.attrs.maxScore()}</h5>
                    : <h5>Not set.</h5>}
            </Grid>
            <Grid gap="5px">
                <small>Acceptances</small>
                <h5>{section.acceptances_count} / {section.participations_count} ({Math.round(section.acceptances_count / section.participations_count * 100) || 0}%)</h5>
            </Grid>
        </Grid>
    )
}